export const TWO_PLAYER_VISIBLE_COLORS = Object.freeze({
    self: Object.freeze({ key: 'blue', hex: '#1687ff', rgb: '22, 135, 255' }),
    opponent: Object.freeze({ key: 'green', hex: '#16c95f', rgb: '22, 201, 95' }),
});

export const getTwoPlayerVisibleRole = (logicalColor, viewerLogicalColor) => (
    logicalColor && viewerLogicalColor && logicalColor === viewerLogicalColor
        ? 'self'
        : 'opponent'
);

export const getTwoPlayerVisibleKey = (logicalColor, viewerLogicalColor) => (
    TWO_PLAYER_VISIBLE_COLORS[getTwoPlayerVisibleRole(logicalColor, viewerLogicalColor)].key
);

export const getTwoPlayerVisibleHex = (logicalColor, viewerLogicalColor) => (
    TWO_PLAYER_VISIBLE_COLORS[getTwoPlayerVisibleRole(logicalColor, viewerLogicalColor)].hex
);
